// extracted by mini-css-extract-plugin
module.exports = {"doc-page-wrapper":"d_q container-lg d-flex p-3","doc-page__title--enterprise":"d_r","doc-page":"d_s","doc-page--with-side-menu":"d_t","doc-page__title":"d_v"};